import { IconName } from 'ui/components'
import { IconButton } from 'ui/components/Buttons'
import { useConfirmation } from 'ui/hooks'
import { Col, FormRow } from 'ui/themes/globalStyles'

import { Address, City, Country, IdNumber, RoleInTransaction, State, ZipCode } from './fields'

import { s } from './styles'

export const InstitutionActivityBranchesItem = ({
  index,
  index2,
  showDeleteButton,
  onRemove
}: {
  index: number
  index2: number
  showDeleteButton: boolean
  onRemove: (index: number) => void
}) => {
  const { open: openDeleteConfirmation, Confirmation } = useConfirmation({
    message: `Are you sure you want to remove this item?`,
    onConfirm: async () => {
      if (index2 !== -1) {
        onRemove(index2)
      }
    },
    confirmationButtonText: 'Delete',
    isConfirmationNegative: true
  })

  return (
    <>
      <Confirmation />
      <s.BranchHeader>
        <s.BranchTitle>Branch Information</s.BranchTitle>
        {showDeleteButton && <IconButton face="negative" icon={IconName.DELETE} onClick={openDeleteConfirmation} />}
      </s.BranchHeader>
      <FormRow style={{ alignItems: 'flex-end' }}>
        <Col>
          <RoleInTransaction index1={index} index2={index2} />
        </Col>
        <Col>
          <Address index1={index} index2={index2} />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <City index1={index} index2={index2} />
        </Col>
        <Col>
          <IdNumber index1={index} index2={index2} />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <State index1={index} index2={index2} />
        </Col>
        <Col>
          <ZipCode index1={index} index2={index2} />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <Country index1={index} index2={index2} />
        </Col>
      </FormRow>
    </>
  )
}
